module.exports = __webpack_public_path__ + "img/6.3e49de91.jpg";